module.exports = __webpack_public_path__ + "img/hakuna_price.26c5c16d.png";